import { render, staticRenderFns } from "./CustomImg.vue?vue&type=template&id=4ea0e34c&"
import script from "./CustomImg.vue?vue&type=script&lang=js&"
export * from "./CustomImg.vue?vue&type=script&lang=js&"
import style0 from "./CustomImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports